import React from "react";
import { useDropzone } from "react-dropzone";

export default function Dropzone({ open, onDrop, description, dropType = "area" }) {
  const accept = {
    "image/jpeg": [],
    "image/png": [],
    "application/pdf": [],
    "audio/mpeg": [],
    "audio/ogg": [],
    "application/zip": [],
    "application/x-zip-compressed": [],
    "multipart/x-zip": [],
  };

  const { getRootProps, getInputProps } = useDropzone({ onDrop, accept });

  return (
    dropType === "area" ? (
      <div {...getRootProps({ className: "dropzone" })}>
        <input
          {...getInputProps()}
          accept=".jpeg,.jpg,.png,.pdf,.mp3,.ogg,.zip"
        />
        <p className="f600-22">Arraste o arquivo ou clique aqui.</p>
        <p className="f600-16">{description}</p>
      </div>
    ) : (
      <div {...getRootProps({ className: "dropzone" })} style={{ width: '95px', height: '48px', border: '1px solid #003cff' }}>
        <input
          {...getInputProps()}
          accept=".jpeg,.jpg,.png,.pdf,.mp3,.ogg,.zip"
        />
        <i className="icon icon-add-document blue i-20" />
      </div>
    )
  );
}
